import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Warning } from '../../../components/warning'

const Forbidden: FC = (): React.ReactElement => {
  const navigate = useNavigate()

  return (
    <Warning
      icon='spam'
      title='Você não tem acesso à esta página'
      description='Seu usuário não contém as permissões necessárias para acessar esta funcionalidade. Verifique seus papéis de usuário com o administrador caso acredite que esta mensagem seja um engano.'
      label='Voltar ao início'
      ariaLabel='Voltar ao início'
      onResolve={() => navigate('/')}
    />
  )
}

export default Forbidden
